import { useState } from 'react'

export type AuthModalType = 'login' | 'register' | 'reminder' | 'checkyouremail' | 'verifyaccount'

export const useAuthModal = () => {
  const [modalType, setModalType] = useState<AuthModalType | null>(null)
  
  return {
    modalType,
    setModalType,
  }
}
